"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getInteractionKey_1 = require("../helpers/getInteraction/getInteractionKey");
const entity_1 = require("../type/entity");
function zeroStateInteractionsOfCheckpoint(content, user, submissionId, reviewerId, timeStamp) {
    const { _id: contentId } = content;
    const { userId, companyId } = user;
    if (!timeStamp) {
        timeStamp = new Date().toISOString();
    }
    const evaluatedInteraction = {
        contentId_interactionType_interactingOnId_actorId: getInteractionKey_1.getInteractionKeyForLearner(contentId, entity_1.InteractionType.Evaluation, submissionId, reviewerId),
        interactionType_contentId_interactingOnId_userId: getInteractionKey_1.getInteractionKeyForActorId(contentId, entity_1.InteractionType.Evaluation, submissionId, userId),
        userId,
        evaluation: entity_1.CheckpointSubmissionStatus.PENDING,
        actorType: entity_1.ActorType.USER,
        contentId,
        rootContentId: contentId,
        submissionId,
        companyId,
        createdAt: timeStamp,
        updatedAt: timeStamp,
        interactionType: entity_1.InteractionType.Evaluation,
        actorId: reviewerId,
        deleted: false,
        reviews: [],
        versionNumber: 0
    };
    return evaluatedInteraction;
}
exports.zeroStateInteractionsOfCheckpoint = zeroStateInteractionsOfCheckpoint;
//# sourceMappingURL=zeroStateInteractionsOfCheckpoint.js.map